/* nutra-wave-atc.js — Loaded deferred after jQuery */

(function () {
  if (!window.location.href.includes('us.nutra-wave.com')) return;

  /* ── Add to Cart: secondary button ── */
  $(document).ready(function () {
    $(".add-to-cart--secondary").on("click", function (e) {
      e.preventDefault();

      var variantId = $(this).attr("data-varid");
      if (!variantId) return;

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ id: variantId, quantity: 1 }),
        contentType: "application/json",
        dataType: "json",
        success: function () {
          window.location.href = "/cart";
        },
        error: function (xhr, status, error) {
          console.error("ATC Error:", error);
        }
      });
    });
  });

  /* ── Sold-out state for secondary buttons ── */
  $(document).ready(function () {
    function updateSoldOutButtons() {
      $(".add-to-cart--secondary").each(function () {
        var $btn = $(this);
        var inventory = parseInt($btn.attr("data-inventory"), 10);
        var handle = $btn.attr("data-handle");

        if (handle === "continue") return;

        if (inventory <= 0) {
          $btn.addClass("sold-out").attr("aria-disabled", "true");
          $btn.find(".metafield-rich_text_field p").text("SOLD OUT");
        }
      });
    }

    updateSoldOutButtons();

    $(document).on("change", "form[action*='/cart/add'] select", function () {
      setTimeout(updateSoldOutButtons, 300);
    });

    $(document).ajaxComplete(function () {
      updateSoldOutButtons();
    });

    $(document).on("click", ".add-to-cart--secondary.sold-out", function (e) {
      e.preventDefault();
      return false;
    });
  });
}());
